import { NoEncryption } from '@material-ui/icons';
import React, { FC, Fragment, useCallback, useState } from 'react';
import { Confirm, useEditContext, useMutation, useNotify, useRefresh } from 'react-admin';
import AppToolbarAction from '../../Components/ui/layout/AppToolbarAction';
import AppMessageDialog from '../../Components/ui/dialog/message-dialog/app-message-dialog';

const AppToolbarRemoveAccess: FC<any> = (props) => {
  const { handleClose: closeMenu, record } = props;
  const { $formStatus } = useEditContext() as any;
  const [hasError, setHasError] = useState(false);
  const [open, setOpen] = useState(false);
  const [mutate] = useMutation();
  const notify = useNotify();
  const refresh = useRefresh();

  const content =
    "Se procedi tutti i dati di accesso dell'utente saranno rimossi e non potrà più accedere alla piattaforma fino a eventuale riattivazione.";
  const title = 'Rimozione accesso utente.';

  const openDialog = () => {
    closeMenu();
    setHasError($formStatus?.dirty);
    setOpen(true);
  };
  const closeDialog = useCallback(() => setOpen(false), []);

  const changeStatus = () => {
    mutate(
      {
        type: 'create',
        resource: 'auth/set-access-state',
        payload: {
          data: {
            user: record.id,
            state: 'inactive',
          },
        },
      },
      {
        onSuccess: () => {
          closeDialog();
          refresh();
          notify('Cancellazione dati di accesso eseguita correttamente.', 'info');
        },
        onFailure: (err) => {
          console.error(err);
          closeDialog();
          notify(`Operazione fallita. ${err.message}.`);
        },
      },
    );
  };

  return (
    <Fragment>
      <AppToolbarAction onClick={openDialog} text="Rimuovi accesso" icon={NoEncryption} />
      {hasError ? (
        <AppMessageDialog
          open={open}
          title="Impossibile procedere"
          content="Sono presenti delle modifiche non salvate."
          onClose={closeDialog}
        />
      ) : (
        <Confirm
          isOpen={open}
          content={content}
          onClose={closeDialog}
          onConfirm={changeStatus}
          title={title}
        />
      )}
    </Fragment>
  );
};

export default AppToolbarRemoveAccess;
